import { createFileRoute, useParams } from '@tanstack/react-router';
import { useMediaQuery } from '../../hooks/use-media-query';
import { useState } from 'react';
import LeftSide from '../../components/Auth/LeftSide';
import RightSide from '../../components/Auth/RightSide';

export const Route = createFileRoute('/payments/$refundId')({
  component: () => <EmailFlow />,
});

function EmailFlow() {
  const isMobile = useMediaQuery('(max-width: 767px)');
  const [isStartClaimProcess, setIsStartClaimProcess] = useState(false);

  const toggleStartClaimProcess = () =>
    setIsStartClaimProcess(!isStartClaimProcess);

  const { refundId } = useParams({ strict: false });

  if (isMobile) {
    return (
      <div className='h-full w-full'>
        {!isStartClaimProcess && (
          <>
            <LeftSide
              isStartClaimProcess={isStartClaimProcess}
              toggleStartClaimProcess={toggleStartClaimProcess}
            />
          </>
        )}
        {isStartClaimProcess && <RightSide refundId={refundId} />}
      </div>
    );
  }

  return (
    <div className='h-full w-full lg:grid lg:grid-cols-2'>
      <LeftSide />
      <RightSide refundId={refundId} />
    </div>
  );
}
